import moment from "moment";

const DATE_FORMAT = 'DD-MM-YYYY';

export default {
    getMomentFromString(str){
        return moment(str, DATE_FORMAT);
    },
    getDateFromString(str){
        return this.getMomentFromString(str).toDate();
    },
    getStringifiedDate(jsDate){
        return moment(jsDate).format(DATE_FORMAT);
    }
}